<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2 safetyApp">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="clickToRowItem"
                            @new-item="newItem"
                            @delete-items="deleteItems"
                            @export="exportItems"
                            @import-items="importItems"
                            :tbody-tr-class="rowClass"
                            ref="gofixTable">
                            <template slot="gofix_table:actions" slot-scope="row" v-if="!row.item.is_add_manual">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:updated_at" slot-scope="row">
                                {{row.item.updated_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                             <template slot="gofix_table:expiry_date" slot-scope="row">
                                {{row.item.expiry_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:import-content" slot-scope="row">
                                <h6><u><i>Workers Template - New Version</i></u></h6>
                                <gofix-button @click="downloadTemplate" label="Workers-Template.csv" outline>
                                    <template  slot="gofix:button:afterLabel">
                                        <i class="icon-cloud-download icons font-xl ml-2"></i>
                                    </template>
                                </gofix-button>
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:updated_at" slot-scope="row">
                                {{row.item.updated_at  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:created_by_name" slot-scope="row">
                                {{row.item.created_by_name ? row.item.created_by_name : 'System Account'}}
                            </template>
                            <template slot="gofix_table:updated_by_name" slot-scope="row">
                                {{row.item.updated_by_name ? row.item.updated_by_name : 'System Account'}}
                            </template>
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            :title="`${modals.add.data.id ? 'Edit' : 'Add'} Worker`" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-input 
                            label="IC/FIN" 
                            required
                            show-icon-required
                            v-model="modals.add.data.ic_fin">
                        </gofix-form-input>
                        <gofix-form-input 
                            label="Name" 
                            required
                            show-icon-required
                            v-model="modals.add.data.name">
                        </gofix-form-input>
                        <!-- <gofix-form-input 
                            label="Department" 
                            v-model="modals.add.data.department">
                        </gofix-form-input> -->
                        <gofix-form-dropdown 
                            label="Company" 
                            vLabel="name"
                            required
                            show-icon-required
                            appendToBody
                            :filterable="false"
                            @search="searchCompanies"
                            v-model="modals.add.data.company" 
                            :options="modals.add.options.companies">
                        </gofix-form-dropdown>
                        <!-- <gofix-form-input 
                            label="Work Permit Number" 
                            required
                            show-icon-required
                            v-model="modals.add.data.work_permit_number">
                        </gofix-form-input> -->
                        <gofix-form-input-date
                            show-icon-required
                            required
                            :minDate="new Date()" 
                            v-model="modals.add.data.expiry_date"
                            label="Work Permit Expiry">
                        </gofix-form-input-date>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import moment from 'moment';
export default {
    name: 'safety-workers-list',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_app_workers_listing']));
        return {
            tableConfig:{
                name: 'safety-app-workers-listing',
                controls:{
                    create: this.$checkRole(this.$accessModule.safety_app_workers, 'create'),
                    delete: this.$checkRole(this.$accessModule.safety_app_workers, 'delete'),
                    tableColumnSettings: false
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "created_at",
                sortDirection: "desc",
                fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 100,
                            thStyle: "width:100px",
                        },
                        {
                            key: 'id',
                            label: 'ID',
                            thStyle: "width:150px",
                            width: 150,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'ic_fin',
                            label: 'IC/FIN',
                            thStyle: "width:200px",
                            width: 200,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'name',
                            label: 'Name',
                            thStyle: "width:300px",
                            width: null,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        /*{
                            key: 'department',
                            label: 'Department',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },*/
                        {
                            key: 'company',
                            label: 'Company',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                        // {
                        //     key: 'work_permit_number',
                        //     label: 'Work Permit Number',
                        //     isActive: 1,
                        //     isFilter: true,
                        //     thStyle: "width:300px",
                        //     width: 150,
                        //     sorting: true
                        // },
                        {
                            key: 'expiry_date',
                            label: 'Work Permit Expiry',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        },
                        {
                            key: 'created_at',
                            label: 'Created At',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            sorting: true
                        },
                        {
                            key: "created_by_name",
                            label: "Created By",
                            thStyle: "width:300px",
                            isActive: true,
                            isFilter: true,
                            sorting: true,
                        },
                        {
                            key: 'updated_at',
                            label: 'Updated At',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            sorting: true
                        },
                        {
                            key: "updated_by_name",
                            label: "Updated By",
                            thStyle: "width:300px",
                            isActive: true,
                            isFilter: true,
                            sorting: true,
                        },
                    ]
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        id: null,
                        name: null,
                        ic_fin: null,
                        department: null,
                        company: null,
                        expiry_date: null,
                        work_permit_number: null,
                        ic_fin_current: null,
                    },
                    options: {
                        companies: []
                    }
                }
            },
            timer: {
                save: null
            },
        }
    },
    computed: {
        // Add computed properties here
    },
    watch: {
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("SafetyAppController/getworkerItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of workers", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },  
        clickToRowItem(item) {
            if(!this.$checkRole(this.$accessModule.safety_app_workers, 'update')) return
            this.modals.add.data = {
                id: item.id,
                name: item.name,
                ic_fin: item.ic_fin,
                department: item.department,
                company: null,
                expiry_date: item.expiry_date ? new Date(item.expiry_date) : null,
                work_permit_number: item.work_permit_number ? item.work_permit_number : null,
                ic_fin_current: item.ic_fin,
            };

            if(item.company_id && item.company) {
                this.modals.add.data.company = {
                    id: item.company_id,
                    name: item.company
                };
            }

            this.modals.add.open = true;
        },
        newItem() {
            if(!this.$checkRole(this.$accessModule.safety_app_workers, 'create')) return
            this.modals.add.data = {
                id: null,
                name: null,
                ic_fin: null,
                department: null,
                company: null,
                expiry_date: null,
                work_permit_number: null,
                ic_fin_current: null,
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteWorkerItems", ids)
            .then(response => {
                let msg = this.$notificationV2('deleting', 'safety_worker');
                if(response.data.data.msg) {
                    msg = this.$alertNotification(response.data.data.msg, "warning");
                    this.$refs.gofixTable.reloadTableItems();
                }
                resolve(msg);
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems(tableRequest) {
            this.$store.dispatch( 'SafetyAppController/exportWorkerItems', tableRequest)
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Workers.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
        },
        async importItems(callback){
            const { file, resolve, reject } = await callback();

            await this.$store.dispatch(`SafetyAppController/importWorkerItems`, {
                fileImport: file
            })
                .then(response => {
                    let variant = 'success';
                    let msg = 'Workers imported successfully.';
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }

                    this.$alertNotification(msg, variant);
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
            },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {
                
                if(!this.modals.add.data.id && !this.modals.add.data.ic_fin) {
                    return this.$alertNotification("IC/FIN is required.", "danger");
                }

                if(!this.modals.add.data.name) {
                    return this.$alertNotification("Name is required.", "danger");
                }

                if(!this.modals.add.data.company) {
                    return this.$alertNotification("Please choose a company.", "danger");
                }

                if(!this.modals.add.data.expiry_date) {
                    return this.$alertNotification("Work Permit Expiry Date is required.", "danger");
                }

                let data = {
                    name: this.modals.add.data.name,
                    company_id: this.modals.add.data.company.id,
                    company: this.modals.add.data.company.name,
                    department: this.modals.add.data.department,
                    expiry_date: this.modals.add.data.expiry_date ? moment(this.modals.add.data.expiry_date).format('YYYY-MM-DD') : null,
                    work_permit_number: this.modals.add.data.work_permit_number,
                }

                if(!this.modals.add.data.id) {
                    data.ic_fin = this.modals.add.data.ic_fin;
                }

                if(this.modals.add.data.ic_fin_current && this.modals.add.data.ic_fin != this.modals.add.data.ic_fin_current) {
                    let pattern = /^[a-zA-Z0-9]+$/;
                    let result = pattern.test(this.modals.add.data.ic_fin);
                    if(!result) {
                        return this.$alertNotification("IC/FIN must contain only letters and numbers", "danger");
                    }

                    data.ic_fin = this.modals.add.data.ic_fin;
                }

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let objeClone = {
                    id: this.modals.add.data.id,
                    data: data
                };
                
                this.$store.dispatch("SafetyAppController/saveWorkerItem", objeClone)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    this.$refs.gofixTable.reloadTableItems();
                    this.$alertNotification(this.$notificationV2('adding', 'safety_worker'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        },
        async getCompanies(search = '') {
            let tableRequest = {
                page: 1, 
                isCMS: 1,
                filter: { 
                    name: { type: "text", value: search, function: "ilike", with: [] },
                    is_supplier: { type: 'boolean', value: true },
                    is_safety: { type: 'boolean', value: true },
                }, 
                limit: 100
            }

            await this.$store.dispatch("OrganizationController/getItemsNoCommit", tableRequest)
                .then(response => {
                    this.modals.add.options.companies = response.data.data.items;
                })
                .catch(err => {})
        },
        async searchCompanies(search, loading) {
            loading(true)
            this.modals.add.options.companies = []
            if (this.timer.companies) {
                clearTimeout(this.timer.companies);
                this.timer.companies = null;
            }
            this.timer.companies = setTimeout(async () => {
                try {
                    await this.getCompanies(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        rowClass(item) {
            if (item && item.expiry_date) {
                let today = moment().format("YYYY-MM-DD");
                if (moment(today).isAfter(moment(item.expiry_date).format("YYYY-MM-DD"))) {
                    return 'bg-danger';
                }
            }
            return null;
        },
        downloadTemplate() {
            let time = moment().valueOf();
            let link = document.createElement('a');
            link.href = `${process.env.VUE_APP_SERVER_URL}/template/safety-import-worker-template.csv?v=${time}`;
            link.setAttribute('download', 'Workers-Template.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
    },
    created() {
        this.getCompanies();
    }
}
</script>